// extracted by mini-css-extract-plugin
export var cardLayout = "_99-1";
export var paginationContainer = "_99-0";